import { mapState } from "vuex";

var Suppliers = {
  created: function() {
    this.fetchProducts();
  },
  methods: {
    fetchProducts() {
      this.$store.dispatch("product/fetchProducts");
    },
  },
  computed: {
    ...mapState("product", ["products"]),
  },
};

export default Suppliers;
